import { Operation } from '@/backend/models/operation';

// Sub-components
export interface SliderControlProps {
  slider: SliderData;
  index: number;
  runView?: boolean;
  onDeleteSlider: (sliderId: string) => void;
  onAutoMax?: (sliderId: string) => void;
  canAutoMax?: boolean;
  operation: Operation;
  disabled?: boolean;
}

export interface DataPoint {
  x: number;
  y: number;
}

export interface GraphItemProps {
  operation: Operation;
  runView?: boolean;
}

export enum SliderType {
  X = 'x',
  Y = 'y'
}

export interface SliderData {
  id: string;
  name: string;
  value: number;
  parameter: any;
  type: SliderType;
}

